import styled from "@emotion/styled";

export const AdditionalCategoriesWrapper = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${({ theme }) => theme.space.space8};
  list-style-type: none;
`;
